import React from 'react';
import is from 'is_js';
import BaseSessionNav from 'components/BaseSessionNav';
import PropTypes from 'prop-types';
import { connect } from 'omni-common-ui';
import { getUnitList, getNextUnit, getPreviousUnit } from 'data/Units/accessors';
import { actions as UiState } from 'data/UiState';

class UnitResourcesNav extends BaseSessionNav {
  _hasNext() {
    return is.existy(this.props.nextSessionLinkHref);
  }

  _hasPrevious() {
    return is.existy(this.props.previousSessionLinkHref);
  }

  _getHeadingText() {
    return this.props.currentGroupName;
  }

  _getAdditionalChildren() {
    return <h2>{this.props.currentUnitName}</h2>;
  }

  render() {
    if (is.existy(this.props.currentGroupName) && is.existy(this.props.currentUnitName)) {
      return super.render();
    }
    return null;
  }
}

UnitResourcesNav.propTypes = Object.assign({
  currentGroupName: PropTypes.string,
  currentUnitName: PropTypes.string,
}, BaseSessionNav.propTypes);

export function mapStateToProps(state, ownProps) {
  const { groupId, unitId } = ownProps.params;
  if (! is.existy(unitId)) return;
  const { buildRoute } = ownProps;
  const group = state.get('rootReducer').get('groups').get(groupId) &&
    state.get('rootReducer').get('groups').get(groupId).data;
  const unitList = getUnitList(state, groupId);
  if (! is.existy(group) || ! is.existy(unitList)) return;

  const currentUnit = unitList.get(`${unitId}`);
  if (! is.existy(currentUnit)) return;

  const previousUnit = getPreviousUnit(state, `${unitId}`, groupId);
  const nextUnit = getNextUnit(state, `${unitId}`, groupId);

  return {
    currentGroupName: group.name,
    currentUnitName: currentUnit.name,
    previousSessionLinkHref: previousUnit && buildRoute({ unitId: previousUnit.id }),
    nextSessionLinkHref: nextUnit && buildRoute({ unitId: nextUnit.id }),
    isHide: ! UiState.getShowNavigationBar(state),
  };
}

export default connect(mapStateToProps, null)(UnitResourcesNav);



// WEBPACK FOOTER //
// ./components/UnitResourcesNav/index.jsx